<template>
  <div
    class="tw:flex tw:flex-col tw:gap-3 tw:rounded-md tw:border tw:border-red-200 tw:bg-red-50 tw:p-4"
    role="alert"
    :data-testid="testid">
    <div class="tw:flex tw:items-start tw:gap-3">
      <IconAlertTriangle class="tw:mt-0.5 tw:shrink-0 tw:text-red-600" :size="18" />
      <span class="tw:flex tw:flex-col tw:gap-0.5">
        <span class="tw:text-13 tw:font-semibold tw:text-gray-900">{{ $t('order_creation_blocked.title') }}</span>
        <span class="tw:text-13 tw:font-normal tw:text-muted" style="text-wrap: pretty">{{
          $t('order_creation_blocked.body')
        }}</span>
      </span>
    </div>
    <div
      v-if="supportEmail"
      class="tw:flex tw:items-center tw:justify-end tw:gap-4 tw:border-t tw:border-red-200 tw:pt-3">
      <a :href="mailtoLink" class="tw:text-13 tw:font-medium tw:text-red-700" :data-testid="`${testid}-contact`">
        {{ supportEmail }}
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { brand } from '@/config/brands';
/**
 * "You can't place an order yet" notice, shown wherever blocked order creation needs explaining
 * - Home and the signup wizard's completion step share this copy and layout by design.
 */
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { IconAlertTriangle } from '@tabler/icons-vue';
import { useUserStore } from '@/stores/user';

interface Props {
  companyName: string;
  testid?: string;
}

const props = withDefaults(defineProps<Props>(), { testid: 'setup-blocked-banner' });

const { supportEmail } = storeToRefs(useUserStore());
const mailtoLink = computed(() => {
  const subject = `${brand.name} Registration Error - ${props.companyName}`;
  return `mailto:${supportEmail.value}?subject=${encodeURIComponent(subject)}`;
});
</script>
